(() => {
  // Both drawers and Theme Editor reloads may load this asset more than once.
  if (window.thehuesMotorizedTrackNotice) return;
  window.thehuesMotorizedTrackNotice = true;
  const statusTimers = new WeakMap();
  const pendingCopies = new WeakSet();

  // Keep the existing click-data analytics contract, counting expansion only.
  document.addEventListener('toggle', (event) => {
    const notice = event.target;
    if (!notice.matches('[data-track-pdp]')) return;
    const summary = notice.querySelector('summary');
    if (notice.open) summary.removeAttribute('click-data');
    else summary.setAttribute('click-data', 'MotorTrack-pdpExpand');
  }, { capture: true });

  document.addEventListener('click', async (event) => {
    const action = event.target.closest('[data-track-copy], [data-track-email]');
    const notice = action?.closest('[data-motorized-track-notice]');
    if (!notice) return;

    if (action.hasAttribute('data-track-email')) {
      const drawer = notice.closest('.measurement');
      const selected = (type) => drawer?.querySelector(`[data-type="${type}"] .optionItem.active`)?.dataset.value || 'Not selected';
      const width = drawer?.querySelector('input[data-type="width"]')?.value || 'Not entered';
      const unit = drawer?.querySelector('[data-type="width"] .first .inputList > .msg')?.textContent.replace('*', '').trim() || '';
      const rod = selected('width');
      const curtain = drawer?.querySelector('[data-type="collections"] .optionItem.active .itemBox')?.textContent.replace(/\s+/g, ' ').trim();
      const root = notice.hasAttribute('data-track-pdp') ? notice.closest('#bcpo:not(.g-card)') : null;
      const widthField = root?.querySelector('select[name*="Width]"]')?.closest('.selector-wrapper');
      const pdpWidth = widthField?.querySelector('.selectInput')?.value.trim()
        || widthField?.querySelector('.itemBox.active[data-text]')?.dataset.text || 'Not entered';
      const pdpUnit = typeof unitType !== 'undefined' && unitType === 'cm' ? 'CM' : 'INCHES';
      const measurements = root ? [
        `Product: ${notice.dataset.context}`,
        `Header: ${root.querySelector('input[name="properties[Header Type]"]:checked')?.value || 'Not selected'}`,
        `Panel width: ${pdpWidth} (${pdpUnit})`,
      ] : [
        ...(curtain ? [`Curtain type: ${curtain}`] : []),
        `Header: ${selected('header')}`,
        `Rod installed: ${rod === 'true' ? 'Yes' : rod === 'false' ? 'No' : 'Not selected'}`,
        `Window width: ${width} ${unit}`,
      ];
      const body = [
        'Hi,',
        '',
        ...measurements,
        `Page: ${notice.dataset.pageUrl}`,
        '',
        'Track brand / model:',
        'Track length:',
      ].join('\r\n');
      action.href = `mailto:${notice.dataset.email}?subject=${encodeURIComponent('Motorized track: ' + notice.dataset.context)}&body=${encodeURIComponent(body)}`;
      return;
    }

    const status = notice.querySelector('[data-track-status]');
    if (action.disabled || pendingCopies.has(action)) return;
    pendingCopies.add(action);
    // Native disabled blurs a keyboard-focused button in Chromium.
    action.setAttribute('aria-disabled', 'true');
    clearTimeout(statusTimers.get(notice));
    status.textContent = '';
    const copyLabel = action.querySelector('[data-track-copy-label]');
    if (copyLabel) copyLabel.textContent = 'Copy';
    action.classList.remove('is-copied');
    try {
      await navigator.clipboard.writeText(notice.dataset.email);
      status.textContent = 'Email address copied.';
      action.classList.add('is-copied');
      if (copyLabel) copyLabel.textContent = 'Copied';
      statusTimers.set(notice, setTimeout(() => {
        status.textContent = '';
        action.classList.remove('is-copied');
        if (copyLabel) copyLabel.textContent = 'Copy';
      }, 3000));
    } catch (_) {
      const email = notice.querySelector('.motorized-track-notice__email');
      try {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(email);
        selection.removeAllRanges();
        selection.addRange(range);
        status.textContent = 'Select and copy the email address above.';
      } catch (_) {
        status.textContent = 'Please copy the email address above manually.';
      }
    } finally {
      pendingCopies.delete(action);
      action.removeAttribute('aria-disabled');
    }
  // Drawer popupBox handlers stop bubbling; capture keeps these controls reachable.
  }, { capture: true });
})();
